export const boxStyling = {
  marginTop: '20px',
  overflow: 'hidden',
  borderRadius: '10px',
  padding: '15px',
  boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)'
};

export const loaderStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
  height: '10%',
  width: '10%',
  display: 'grid',
  placeItems: 'center center'
};
